<template>
  <div class="q-pa-sm">
    <task-queues
      :options="options"
      @select="onRowDblClick"
    />
  </div>
</template>

<script>
// Vuex
import { mapMutations } from 'vuex'

// Components
import TaskQueues from '../../components/queue/TaskQueues.vue'

export default {
  name: 'RevisionQueues',
  components: {
    TaskQueues
  },
  computed: {
    options () {
      return {
        settings: true,
        waveSettings: true,
        type: 'revision',
        title: 'Revision Queues',
        service: this.$service.pickingQueue,
        adapters: ['revision']
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPickingQueue'
    ]),
    onRowDblClick ({ item, toFilters }) {
      this.setPickingQueue(item)
      const path = `/workstation/queues/revision/entity/${item.id}${toFilters ? '?start=true' : ''}`
      this.$router.push(path)
    }
  }
}
</script>
